import { Calendar as Calendar_kojaro } from './Calendar.kojaro';
import { Calendar as Calendar_phosphor } from './Calendar.phosphor';
import { Calendar as Calendar_zoomg } from './Calendar.zoomg';
import { Calendar as Calendar_zoomit } from './Calendar.zoomit';

const IconRenderer = () => {
  switch (process.env.NEXT_PUBLIC_ICON_SYSTEM) {
    case 'kojaro':
      return Calendar_kojaro;

    case 'zoomg':
      return Calendar_zoomg;

    case 'phosphor':
      return Calendar_phosphor;

    default:
      return Calendar_zoomit;
  }
};

export const Calendar = IconRenderer();
